import gql from 'graphql-tag';

export default gql`
  fragment LessonTemplateFragment on LessonTemplate {
    _id
    title
    student {
      _id
    }
    isTeacherLessonTemplate
    isPersonalLessonTemplate
    creator {
      _id
    }
    courseCategory {
      _id
      title
    }
  }
`;
